import { render, staticRenderFns } from "./PointSettingDetailTop.vue?vue&type=template&id=32ca568e&"
import script from "./PointSettingDetailTop.vue?vue&type=script&lang=js&"
export * from "./PointSettingDetailTop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports